module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Vehicle Deails")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Vehicle")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_VehicleMaster_Report', 'Export as Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.veiwVehicleMaster.length > 0) ? _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "2"
    }
  }, [(_vm.veiwVehicleMaster.length > 0) ? _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.exportVehiclesDetailsReportDashboard()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBtnName) + "\n                "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.StatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.viewTypeSize
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwVehicleMaster,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "rc_sale_amt",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "regdNo",
      fn: function(row1) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.editVehicleDetail(row1.item.vehicleTruckId)
            }
          }
        }, [_vm._v(_vm._s(row1.item.regdNo))]), _vm._v(" "), _c('br'), _vm._v(" "), (
          row1.item.isTruckMasterActive == '1' &&
          row1.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Available")])], 1) : _vm._e(), _vm._v(" "), (
          row1.item.isTruckMasterActive == '0' &&
          row1.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Booked")])], 1) : _vm._e(), _vm._v(" "), (row1.item.vehicleActiveInactiveId == '2') ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("INACTIVE")])], 1) : _vm._e()]
      }
    }, {
      key: "isTruckMasterActive",
      fn: function(row21) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row21.item.vehicleTruckId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row21.item.vehicleTruckId,
            "name": "approval",
            "value": row21.item.isTruckMasterActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateBookVehicle(row21.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s((row21.item.isTruckMasterActive == '0' &&
          row21.item.vehicleActiveInactiveId == '1') ? "Booked" : (row21.item.isTruckMasterActive == '1' &&
          row21.item.vehicleActiveInactiveId == '1') ? "Available" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row21.item.vehicleTruckId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s((row21.item.isTruckMasterActive == '0' &&
          row21.item.vehicleActiveInactiveId == '1') ? "Booked" : (row21.item.isTruckMasterActive == '1' &&
          row21.item.vehicleActiveInactiveId == '1') ? "Available" : "In-Active"))])], 1)])]
      }
    }, {
      key: "status",
      fn: function(row21) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row21.item.vehicleTruckId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row21.item.vehicleTruckId,
            "name": "approval",
            "value": row21.item.vehicleActiveInactiveId == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateVehicle(row21.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row21.item.vehicleActiveInactiveId == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row21.item.vehicleTruckId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row21.item.vehicleActiveInactiveId == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "vehicleTruckId",
      fn: function(row) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-info",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.showDirection(row.item.vehicleTruckId)
            }
          }
        }, [_vm._v("Track Vehicle")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-703723f2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleMaster/viewVehicleDetail.vue
// module id = 2739
// module chunks = 0